import { Field, TextOutput } from 'Components/Core';
import { Grid, PageSection } from 'Components/Layout';
import { IAgsExportRevision } from 'Data/ViewModels/Ags';
import { FormatTypes } from 'Lib/Format';
import React, { useState } from 'react';
import { AgsFileButton } from '../AgsFileButton';
import { ValidationMessagesDialog } from '../ValidationMessagesDialog';

interface IAgsExportHistory {
  colWidths: Array<string>;
  minColWidths?: Array<string>;
  name: string;
  data: Array<IAgsExportRevision>;
  withDateRange: boolean;
}

const AgsExportHistory: React.FC<IAgsExportHistory> = ({ colWidths, minColWidths, name, data, withDateRange }) => {
  let colHeaders = ['Start Date', 'End Date', 'Issue No', 'Date Created', 'Size', 'AGS Export Configuration', 'File'];

  const [dialogVisible, setDialogVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState({} as IAgsExportRevision);

  // Methods to show/hide Dialog
  const showMessageDialog = (row: IAgsExportRevision) => {
    setSelectedRow(row);
    setDialogVisible(true);
  };
  const hideMessageDialog = () => {
    setDialogVisible(false);
    setSelectedRow({} as IAgsExportRevision);
  };

  const gridData = data?.map((row) => [
    <Field input={<TextOutput />} value={row.StartDate} format={{ type: FormatTypes.Date }} />,
    <Field input={<TextOutput />} value={row.EndDate} format={{ type: FormatTypes.Date }} />,
    <Field input={<TextOutput />} value={row.IssueNumber} />,
    <Field input={<TextOutput />} value={row.CreationDate} format={{ type: FormatTypes.DateTime }} />,
    <Field input={<TextOutput />} value={row.FileSizeBytes} format={{ type: FormatTypes.FileSize }} />,
    <Field input={<TextOutput />} value={row.AgsExportConfigurationName} />,
    <AgsFileButton row={row} onClick={showMessageDialog}></AgsFileButton>,
  ]);

  const hiddenCols = withDateRange ? [] : [0, 1];

  return (
    <>
      <PageSection heading="AGS Export History" id={name}>
        <Grid
          colHeaders={colHeaders}
          colWidths={colWidths}
          minColWidths={minColWidths}
          data={gridData}
          hiddenCols={hiddenCols}
        />
        <ValidationMessagesDialog
          dialogVisibleState={dialogVisible}
          revisionId={selectedRow.Id}
          onClose={hideMessageDialog}
        />
      </PageSection>
    </>
  );
};

export { AgsExportHistory };
